export const elementsIds = {
  map: 'map',
  questionsTable: 'questions-table',
  templatesTable: 'templates-table',
  activeGamesTable: 'active-games-table',
  historyGamesTable: 'history-games-table',
};
